export const ROW_CLASS = 'layout-body flex shrink-0 items-center gap-2 px-4 py-2'

export const MODAL_ROW_CLASS = 'flex w-full shrink-0 items-center gap-2'
